var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasOrganisationLoaded)?_c('div',[(_vm.notAPublicRoute)?_c('DiscountBanner',{on:{"bannerActive":function($event){_vm.discountBannerActivated = $event}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }